var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 11.6667C12.3009 11.6667 14.1663 9.80118 14.1663 7.49999C14.1663 5.19881 12.3009 3.33333 9.99967 3.33333C7.69849 3.33333 5.83301 5.19881 5.83301 7.49999C5.83301 9.80118 7.69849 11.6667 9.99967 11.6667ZM9.99967 11.6667C6.31778 11.6667 3.33301 13.9052 3.33301 16.6667M9.99967 11.6667C13.6816 11.6667 16.6663 13.9052 16.6663 16.6667",
    stroke: "#807D7E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f58d3bcba28dea80ad4c374126bdfd74.svg";
export { ForwardRef as ReactComponent };